import { ShieldCheck, Bot, Megaphone, Settings, Building2, Cpu, Sparkles } from "lucide-react";

const map = {
  "shield-check": ShieldCheck,
  bot: Bot,
  megaphone: Megaphone,
  settings: Settings,
  building: Building2,
  cpu: Cpu,
};

export const ServiceIcon = ({ name, className }) => {
  const Ico = map[name] || Sparkles;
  return <Ico className={className} />;
};
